// Display only source-defined choices. CP validates them again on the server.
import { resolveDefinitionChoice } from '../combatpro/players/definitionChoiceEngine';

export const ABILITIES=['str','dex','con','int','wis','cha'];
export const ABILITY_NAMES={str:'Strength',dex:'Dexterity',con:'Constitution',int:'Intelligence',wis:'Wisdom',cha:'Charisma'};
export const emptySpells=() => ({cantrips:[],known:[],prepared:[]});
export function blankChoice(choice) { return Array.from({length:choice.choose},() => ({optionIndex:-1})); }
export function blankOption(option,index) {
  if (option?.option_type==='choice') return {optionIndex:index,selection:blankChoice(option.choice)};
  if (option?.option_type==='multiple') return {optionIndex:index,selection:option.items.map(blankOption)};
  return {optionIndex:index};
}
export function optionLabel(option) {
  if (typeof option==='string') return option;
  if (option.option_type==='reference') return option.item.name;
  if (option.option_type==='ability_bonus') return `${option.ability_score.name} +${option.bonus}`;
  if (option.option_type==='choice') return option.choice.desc || `Choose ${option.choice.choose} ${option.choice.type || 'options'}`;
  if (option.option_type==='multiple') return option.items.map(optionLabel).join(' and ');
  return 'Unavailable source option';
}
export function leaves(choice,selection) {
  try { return resolveDefinitionChoice(choice,selection || []); } catch { return []; }
}
export function ancestryChoiceGroups(variant,selections) {
  if (!variant) return [];
  const groups=[]; const race=variant.race;
  for (const key of ['language_options','ability_bonus_options']) {
    if (race[key]) groups.push({key:'race.'+key,label:key==='language_options' ? 'Ancestry language' : 'Ancestry ability increases',definition:race[key]});
  }
  const traits=new Map(variant.traits.map(row => [row.index,row])); const seen=new Set();
  function visit(ref,depth=0) {
    if (depth>20 || seen.has(ref)) throw new Error('Invalid ancestry choice graph');
    const trait=traits.get(ref); if (!trait) throw new Error('Missing ancestry source');
    seen.add(ref);
    for (const key of ['proficiency_choices','language_options']) {
      if (trait[key]) groups.push({key:ref+'.'+key,label:trait.name,definition:trait[key]});
    }
    for (const key of ['subtrait_options','spell_options']) {
      const definition=trait.trait_specific?.[key]; if (!definition) continue;
      groups.push({key:ref+'.'+key,label:trait.name,definition});
      if (key==='subtrait_options') leaves(definition,selections[ref+'.'+key]).forEach(row => visit(row.ref,depth+1));
    }
  }
  race.traits.concat(variant.subrace?.racial_traits || []).forEach(row => visit(row.index));
  return groups;
}
export function classChoiceGroups(variant,selections) {
  if (!variant) return [];
  const defs=new Map(variant.features.concat(variant.choice_features).map(row => [row.index,row]));
  const groups=[]; const seen=new Set();
  function visit(ref,depth=0) {
    if (depth>20 || seen.has(ref)) throw new Error('Invalid class choice graph');
    seen.add(ref); const feature=defs.get(ref); if (!feature) throw new Error('Missing class source');
    for (const [key,definition] of Object.entries(feature.feature_specific || {})) {
      groups.push({key:ref,label:feature.name,definition});
      if (key==='subfeature_options') leaves(definition,selections[ref]).forEach(row => visit(row.ref,depth+1));
    }
  }
  variant.features.forEach(row => visit(row.index)); return groups;
}
export function pruneSelections(groups,selections) {
  return Object.fromEntries(groups.filter(row => Object.hasOwn(selections,row.key)).map(row => [row.key,selections[row.key]]));
}
export function initialChoices() {
  return {race_ref:'human',subrace_ref:null,assignment:Object.fromEntries(ABILITIES.map((ref,index) => [ref,index])),
    ancestry_selections:{},class_ref:'wizard',subclass_ref:null,class_proficiency_selections:[],
    background_ref:'acolyte',background_selections:{tool_choices:[],languages:[]},proficiency_replacements:[],
    feature_selections:{},spell_selection:emptySpells()};
}
export function contextChoices(choices) {
  return Object.fromEntries(Object.entries(choices).filter(([key]) => !['feature_selections','spell_selection'].includes(key)));
}
